<template>
  <div class="checkboxes-action">
    <template v-if="data.hasGroups">
      <div
        v-for="(optionGroup, optionGroupIndex) in options"
        :key="optionGroupIndex"
        class="option-group"
        :class="{ 'is-large': isLarge }">
        <h5
          class="option-group-title"
          @click="openGroup(optionGroupIndex)">
          <i :class="openedGroup === optionGroupIndex ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          <span>{{ optionGroup.label }}</span>
        </h5>
        <div
          v-show="openedGroup === optionGroupIndex"
          class="options">
          <el-checkbox
            v-for="(box, optionIndex) in optionGroup.options"
            :key="optionIndex"
            v-model="box.checked"
            class="option"
            border>
            {{ box.label }}
          </el-checkbox>
        </div>
      </div>
    </template>

    <template v-else>
      <el-checkbox
        v-for="(box, index) in options"
        :key="index"
        v-model="box.checked"
        class="option"
        border>
        {{ box.label }}
      </el-checkbox>
    </template>

    <ButtonAction
      class="mt-3"
      :data="{ label: data.label }"
      :is-disabled="isValidationDisabled"
      :is-large="isLarge"
      @validate="validate" />
  </div>
</template>

<script>
import ButtonAction from "@/components/chatbot/Bubbles/actions/ButtonAction"

export default {
  name: "CheckboxesAction",
  components: { ButtonAction },
  props: {
    data: {
      type: Object,
      required: true
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      openedGroup: null
    }
  },
  computed: {
    isValidationDisabled() {
      let options = this.options
      if (this.data.hasGroups) {
        options = Array.prototype.concat.apply([], options.map(optionGroup => optionGroup.options))
      }

      if (!options.length) {
        return true
      }

      if (this.data.areAllCheckboxesRequired) {
        return options.some(o => !o.checked)
      }

      if (this.data.isAtLeastOneCheckboxeRequired) {
        return !options.some(o => o.checked)
      }

      return false
    }
  },
  created() {
    this.options = JSON.parse(JSON.stringify(this.data.options))
  },
  methods: {
    openGroup(index) {
      if (index !== this.openedGroup) {
        this.openedGroup = index
        return
      }

      this.openedGroup = null
    },
    validate() {
      let options = this.options
      if (this.data.hasGroups) {
        options = Array.prototype.concat.apply([], options.map(optionGroup => optionGroup.options))
      }
      options = options.filter(o => o.checked)

      this.$emit("validate", options.map(o => o.id))
    }
  }
}
</script>

<style lang="scss">
.checkboxes-action {
  .el-checkbox {
    .el-checkbox__label {
      font-size: 14px;
      white-space: normal;
      padding-left: 0;
    }

    .el-checkbox__input {
      display: none;
    }
  }

  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-left: 0;
  }
}
</style>

<style lang="scss" scoped>
.checkboxes-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  flex-shrink: 0;

  &.is-large {
    width: auto;
  }

  .option-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    width: 100%;

    &:last-of-type {
      margin-bottom: 0;
    }

    .option-group-title {
      text-align: center;
      background-color: color(paperWhite);
      padding: 10px 16px;
      border-radius: 18px;
      margin: 0 0 8px 0;
      cursor: pointer;

      &:hover {
        background-color: color(gray05);
      }

      i {
        color: color(deepSeaBlue);
        margin-right: 8px;
        font-weight: 700;
      }
    }
  }

  .options {
    display: flex;
    flex-direction: column;
  }

  .option {
    text-align: center;
    margin: 0 0 8px 0;
    min-width: 40%;
    height: auto;
    padding: 8px 18px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
